import BillingClientDirectoryPage from "pages/directory/BillingClientDirectory";
import CustomersDirectoryPage from "pages/directory/CustomersDirectory";
import StaffDirectoryPage from "pages/directory/StaffDirectory";
import StrCompanyDirectoryPage from "pages/directory/StrCompanyDirectory";
import StrDirectoryPage from "pages/directory/StrDirectory";
import { Route } from "react-router-dom";

const routes = {
  key: "DIRECTORY",
  routes: ({ userScope }) => [
    <Route key="directory" path={`${userScope}/directory`}>
      <Route
        key="directory-staff"
        path="staff"
        element={<StaffDirectoryPage />}
      />
      <Route key="directory-str" path="str" element={<StrDirectoryPage />} />
      <Route
        key="directory-customers"
        path="customers"
        element={<CustomersDirectoryPage />}
      />
      <Route
        key="directory-billing-client"
        path="billing-client"
        element={<BillingClientDirectoryPage />}
      />
      <Route
        key="directory-company-str"
        path="company/str"
        element={<StrCompanyDirectoryPage />}
      />
    </Route>,
  ],
};
export default routes;
